<script lang="ts">
	/** Provide the ARIA labelledby value. */
	export let labelledby = '';
  let classes: string = ''
  export {classes as class}
</script>

<div class="radio-group {classes}" role="radiogroup" aria-labelledby={labelledby}>
	<slot />
</div>

<style lang="scss" global>
	.radio-group {
		font-size: inherit;
	}
</style>